import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { UserService ,User } from '../../../../shared/service/user.service';

import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';
import { TagModule } from 'primeng/tag';
import { PasswordModule } from 'primeng/password';
import { TooltipModule } from 'primeng/tooltip';
import { InputNumberModule } from 'primeng/inputnumber';
import { AccordionModule } from 'primeng/accordion';

import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiCredentialCreate, ApiCredentialResponse, ApiCredentialsService, ApiCredentialUpdate, ApiName } from '../../services/api-credentials.service';

interface GroupedCredentials {
  username: string;
  email: string; // Ajout du champ email
  userId: number;
  credentials: ApiCredentialResponse[];
  totalCredentials: number;
  apis: string[];
}

@Component({
  selector: 'app-api-credentials',
  standalone: true,
  imports: [
    CommonModule, 
    ReactiveFormsModule,
    TableModule,
    CardModule,
    ButtonModule,
    InputTextModule,
    DropdownModule,
    DialogModule,
    ConfirmDialogModule,
    ToastModule,
    TagModule,
    PasswordModule,
    TooltipModule,
    InputNumberModule,
    AccordionModule,
    FormsModule
  ],
  templateUrl: './api-credentials.component.html',
  styleUrl: './api-credentials.component.css',
  providers: [ConfirmationService]
})
export class ApiCredentialsComponent implements OnInit {

  credentials: ApiCredentialResponse[] = [];
  groupedCredentials: GroupedCredentials[] = [];
  users: User[] = [];
  credentialForm: FormGroup;
  editForm: FormGroup;
  userFilterForm: FormGroup;
  loading = false;
  showAddDialog = false;
  showEditDialog = false;
  showUserFilterDialog = false;
  editingCredential: ApiCredentialResponse | null = null;
  viewMode: 'grouped' | 'table' = 'grouped';
  
  // Options pour dropdown
  apiNameOptions = [
    { label: 'April', value: ApiName.APRIL },
    { label: 'Cardif', value: ApiName.CARDIF },
    { label: 'Utwin', value: ApiName.UTWIN },
    { label: 'Neoliane', value: ApiName.NEOLIANE },
    { label: 'Afi Esca', value: ApiName.AFIESCA },
    { label: 'Zenioo', value: ApiName.ZENIOO },
    { label: 'Ringover', value: ApiName.RINGOVER }
  ];

  /** Guide des clés attendues par API — affiché dans le dialog de création. */
  readonly credentialKeysGuide: Record<string, { key: string; description: string }[]> = {
    april: [
      { key: 'client_id', description: 'Client ID April' },
      { key: 'client_secret', description: 'Client Secret April' }
    ],
    cardif: [
      { key: 'code', description: 'Code entité distributeur Cardif' }
    ],
    utwin: [
      { key: 'username', description: 'Login UTWIN' },
      { key: 'password', description: 'Mot de passe UTWIN' }
    ],
    NEOLIANE: [
      { key: 'client_id', description: 'Client ID Neoliane' },
      { key: 'client_secret', description: 'Client Secret Neoliane' }
    ],
    afiesca: [
      { key: 'api_key', description: 'Clé API SOAP Afi Esca' }
    ],
    zenioo: [
      { key: 'login', description: 'Email courtier Zenioo' },
      { key: 'password', description: 'Mot de passe Zenioo' },
      { key: 'code_courtier', description: 'Code courtier Zenioo' }
    ],
    ringover: [
      { key: 'API Keys', description: 'Clé API Ringover (Dashboard Ringover → Developer → API Keys → copier la clé). Le numéro appelant est lu automatiquement depuis votre profil utilisateur.' }
    ]
  };

  get currentApiKeysGuide(): { key: string; description: string }[] {
    const apiName = (this.credentialForm.get('api_name')?.value as string || '');
    return this.credentialKeysGuide[apiName] || [];
  }

  // Options pour les utilisateurs
  userOptions: { label: string; value: number }[] = [];
commissionSettings: { [key: string]: string } = {};
partners: { key: string, label: string }[] = [
  { key: 'APRIL', label: 'April' },
  { key: 'CARDIF', label: 'Cardif' },
  { key: 'UTWIN', label: 'Utwin' },
  { key: 'NEOLIANE', label: 'Neoliane' },
  { key: 'AFIESCA', label: 'Afi Esca' },
  { key: 'ZENIOO', label: 'Zenioo' }
];
commissionListDisplay: {
  partner: string,
  label: string,
  current: string,
  options: { label: string, value: string }[]
}[] = [];
commissionLoading = false;
commissionList: { partner: string, label: string, current: string, options: string[] }[] = [];
  constructor(
    private apiCredentialsService: ApiCredentialsService,
    private userService: UserService,
    private fb: FormBuilder,
    private confirmationService: ConfirmationService,
    private messageService: MessageService
  ) {
    this.credentialForm = this.fb.group({
      user_id: [null, [Validators.required]],
      api_name: ['', Validators.required],
      credential_key: ['', Validators.required],
      credential_value: ['', Validators.required]
    });

    this.editForm = this.fb.group({
      api_name: [''],
      credential_key: [''],
      credential_value: ['']
    });

    this.userFilterForm = this.fb.group({
      user_id: [null, [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.loadAllCredentials();
    this.loadUsers();
    this.loadCommissions();
  }

  /**
   * Charger tous les utilisateurs pour les dropdowns
   */
  loadUsers(): void {
    this.userService.getUsers().subscribe({
      next: (users) => {
        this.users = users;
        this.userOptions = users.map(user => ({
          label: `${user.username} (${user.email})`,
          value: user.id
        }));
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Erreur lors du chargement des utilisateurs'
        });
      }
    });
  }
loadCommissions(): void {
  this.commissionLoading = true;
  this.apiCredentialsService.getCommissionSettings().subscribe({
    next: (settings) => {
      this.commissionSettings = settings;
      
      this.commissionListDisplay = this.partners
        .filter(p => p.key !== 'UTWIN') // Utwin n'a pas de commission
        .map((p) => {
        let options: { label: string, value: string }[] = [];
        
        // APRIL - Codes de commission avec libellés
        if (p.key === 'APRIL') {
          options = [
            { label: '08/08', value: '0808' },
            { label: '12/12', value: '1212' },
            { label: '15/15', value: '1515' },
            { label: '20/20', value: '2020' },
            { label: '30/30', value: '3030' },
            { label: '40/10', value: '4010' },
            { label: '50/10', value: '5010' },
            { label: '50/15', value: '5015' },
            { label: '50/20', value: '5020' },
            { label: '0%', value: 'HORCOM' },
          ];
        }
        
        // CARDIF - IDs ESC avec libellés
        if (p.key === 'CARDIF') {
          options = [
            { label: 'P10', value: 'ESC-297943905' },
            { label: 'P15', value: 'ESC-446898905' },
            { label: 'P (Défaut)', value: 'ESC-595853905' },
            { label: 'P25', value: 'ESC-744808905' },
            { label: 'P30', value: 'ESC-893763905' },
          ];
        }
        
        // NEOLIANE - Codes UXX/UXXXX
        if (p.key === 'NEOLIANE') {
          options = ['U10', 'U15', 'U20', 'U25', 'U30', 'U3010', 'U35', 'U40', 'U4010', 'U4015', 'U5', 'U5010', 'U5515', 'U6020']
            .map(o => ({ label: o, value: o }));
        }
        
        // AFI ESCA - Champ numérique, pas de dropdown (options vide)
        if (p.key === 'AFIESCA') {
          options = [];
        }
        
        // ZENIOO - Format X/Y
        if (p.key === 'ZENIOO') {
          options = ['0/0', '08/08', '10/10', '12/12', '15/15', '20/10', '20/20', '30/10', '40/10', '50/10', '50/15']
            .map(o => ({ label: o, value: o }));
        }
        
        let current = settings[p.key.toLowerCase()] ? String(settings[p.key.toLowerCase()]) : '';
        
        // Ajouter la valeur actuelle si elle n'est pas dans les options (pour dropdown uniquement)
        if (p.key !== 'AFIESCA' && current && !options.find(o => o.value === current)) {
          options = [{ label: current, value: current }, ...options];
        }
        
        return {
          partner: p.key,
          label: p.label,
          current,
          options
        };
      });
      
      this.commissionLoading = false;
    },
    error: () => {
      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: 'Erreur lors du chargement des commissions'
      });
      this.commissionLoading = false;
    }
  });
}

onChangeCommission(partner: string, code: string) {
  this.commissionLoading = true;
  this.apiCredentialsService.updateCommission(partner, code).subscribe({
    next: () => {
      this.loadCommissions();
      this.messageService.add({
        severity: 'success',
        summary: 'Commission modifiée',
        detail: `Commission pour ${partner} mise à jour`
      });
      this.commissionLoading = false;
    },
    error: () => {
      this.commissionLoading = false;
    }
  });
}
  onGlobalFilter(event: Event, dt: any) {
    const target = event.target as HTMLInputElement;
    dt.filterGlobal(target.value, 'contains');
  }

  /**
   * Grouper les credentials par utilisateur
   */
  private groupCredentialsByUser(): void {
  const groups = new Map<number, GroupedCredentials>();

  this.credentials.forEach(credential => {
    const userId = credential.user_id;
    const username = credential.user?.username || `Utilisateur ${userId}`;
    const email = credential.user?.email || 'Email non disponible'; // Récupération de l'email
    
    if (!groups.has(userId)) {
      groups.set(userId, {
        username,
        email, // ✅ AJOUT DE L'EMAIL ICI
        userId,
        credentials: [],
        totalCredentials: 0,
        apis: []
      });
    }

    const group = groups.get(userId)!;
    group.credentials.push(credential);
    group.totalCredentials++;
    
    if (!group.apis.includes(credential.api_name)) {
      group.apis.push(credential.api_name);
    }
  });

  this.groupedCredentials = Array.from(groups.values()).sort((a, b) => 
    a.username.localeCompare(b.username)
  );
}

  /**
   * Charger toutes les credentials (Admin)
   */
  loadAllCredentials(): void {
    this.loading = true;
    this.apiCredentialsService.getAllApiCredentials().subscribe({
      next: (credentials) => {
        this.credentials = credentials;
        this.groupCredentialsByUser();
        this.loading = false;
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Erreur lors du chargement des credentials'
        });
        this.loading = false;
      }
    });
  }

  /**
   * Charger les credentials d'un utilisateur spécifique
   */
  loadCredentialsByUser(): void {
    if (this.userFilterForm.valid) {
      this.loading = true;
      const userId = this.userFilterForm.get('user_id')?.value;
      const selectedUser = this.users.find(user => user.id === userId);
      
      this.apiCredentialsService.getCredentialsByUserId(userId).subscribe({
        next: (credentials) => {
          this.credentials = credentials;
          this.groupCredentialsByUser();
          this.showUserFilterDialog = false;
          this.loading = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Succès',
            detail: `${credentials.length} credential(s) trouvée(s) pour ${selectedUser?.username || `l'utilisateur ${userId}`}`
          });
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: 'Utilisateur non trouvé ou erreur lors du chargement'
          });
          this.loading = false;
        }
      });
    }
  }

  /**
   * Filtrer par API
   */
  filterByApi(apiName: ApiName): void {
    this.loading = true;
    this.apiCredentialsService.getCredentialsByApi(apiName).subscribe({
      next: (credentials) => {
        this.credentials = credentials;
        this.groupCredentialsByUser();
        this.loading = false;
        this.messageService.add({
          severity: 'info',
          summary: 'Filtre appliqué',
          detail: `${credentials.length} credential(s) pour ${apiName}`
        });
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Erreur lors du filtrage par API'
        });
        this.loading = false;
      }
    });
  }

  onSubmit(): void {
    if (this.credentialForm.valid) {
      this.loading = true;
      console.log('Form values:', this.credentialForm.value); 
      const credentialData: ApiCredentialCreate = this.credentialForm.value;
      
      this.apiCredentialsService.createApiCredential(credentialData).subscribe({
        next: (response) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Succès',
            detail: 'Credential créée avec succès'
          });
          this.loadAllCredentials();
          this.resetForm();
          this.showAddDialog = false;
          this.loading = false;
        },
        error: (error) => {
          let errorMessage = 'Erreur lors de la création de la credential';
          if (error.error?.detail) {
            errorMessage = error.error.detail;
          }
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: errorMessage
          });
          this.loading = false;
        }
      });
    }
  }

  editCredential(credential: ApiCredentialResponse): void {
    this.editingCredential = credential;
    this.editForm.patchValue({
      api_name: credential.api_name,
      credential_key: credential.credential_key,
      credential_value: credential.credential_value
    });
    this.showEditDialog = true;
  }

  updateCredential(): void {
    if (this.editingCredential) {
      this.loading = true;
      const updateData: ApiCredentialUpdate = {};
      
      const formValue = this.editForm.value;
      if (formValue.api_name && formValue.api_name !== this.editingCredential.api_name) {
        updateData.api_name = formValue.api_name;
      }
      if (formValue.credential_key && formValue.credential_key !== this.editingCredential.credential_key) {
        updateData.credential_key = formValue.credential_key;
      }
      if (formValue.credential_value && formValue.credential_value !== this.editingCredential.credential_value) {
        updateData.credential_value = formValue.credential_value;
      }

      if (Object.keys(updateData).length === 0) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Attention',
          detail: 'Aucune modification détectée'
        });
        this.loading = false;
        return;
      }

      this.apiCredentialsService.updateApiCredential(this.editingCredential.id, updateData).subscribe({
        next: (response) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Succès',
            detail: 'Credential modifiée avec succès'
          });
          this.loadAllCredentials();
          this.cancelEdit();
          this.loading = false;
        },
        error: (error) => {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: 'Erreur lors de la modification'
          });
          this.loading = false;
        }
      });
    }
  }

  deleteCredential(credential: ApiCredentialResponse): void {
    const username = credential.user?.username || `Utilisateur ${credential.user_id}`;
    this.confirmationService.confirm({
      message: `Êtes-vous sûr de vouloir supprimer la credential "${credential.api_name} - ${credential.credential_key}" de ${username} ?`,
      header: 'Confirmation de suppression',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Non',
      accept: () => {
        this.loading = true;
        this.apiCredentialsService.deleteApiCredential(credential.id).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Succès',
              detail: 'Credential supprimée avec succès'
            });
            this.loadAllCredentials();
            this.loading = false;
          },
          error: (error) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erreur',
              detail: 'Erreur lors de la suppression'
            });
            this.loading = false;
          }
        });
      }
    });
  }

  /**
   * Voir la credential complète (non masquée)
   */
  viewFullCredential(credential: ApiCredentialResponse): void {
    this.loading = true;
    this.apiCredentialsService.getFullCredential(credential.id).subscribe({
      next: (fullCredential) => {
        this.messageService.add({
          severity: 'info',
          summary: 'Credential complète',
          detail: `Valeur: ${fullCredential.credential_value}`,
          life: 10000 // Afficher pendant 10 secondes
        });
        this.loading = false;
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Erreur lors de la récupération de la credential complète'
        });
        this.loading = false;
      }
    });
  }

  resetForm(): void {
    this.credentialForm.reset();
  }

  cancelEdit(): void {
    this.editingCredential = null;
    this.editForm.reset();
    this.showEditDialog = false;
  }

  toggleViewMode(): void {
    this.viewMode = this.viewMode === 'grouped' ? 'table' : 'grouped';
  }

  getSeverity(apiName: string): 'success' | 'info' | 'warn' | 'danger' {
    switch (apiName.toLowerCase()) {
      case 'april': return 'success';
      case 'cardif': return 'info';
      case 'utwin': return 'warn';
      case 'neoliane': return 'danger';
      case 'afiesca': return 'info';
      case 'zenioo': return 'warn';
      case 'ringover': return 'success';
      default: return 'info';
    }
  }

  getAprilCount(): number {
    return this.credentials.filter(cred => cred.api_name === ApiName.APRIL).length;
  }

  getCardifCount(): number {
    return this.credentials.filter(cred => cred.api_name === ApiName.CARDIF).length;
  }

  getUtwinCount(): number {
    return this.credentials.filter(cred => cred.api_name === ApiName.UTWIN).length;
  }

  getTotalUsers(): number {
    const uniqueUsers = new Set(this.credentials.map(cred => cred.user_id));
    return uniqueUsers.size;
  }

  /**
   * Méthodes helper pour l'affichage des utilisateurs
   */
  getUserDisplayName(userId: number): string {
    const user = this.users.find(u => u.id === userId);
    return user ? `${user.username} (${user.email})` : `Utilisateur ${userId}`;
  }

  getUserName(userId: number): string {
    const user = this.users.find(u => u.id === userId);
    return user ? user.username : `Utilisateur ${userId}`;
  }

  getUserEmail(userId: number): string {
    const user = this.users.find(u => u.id === userId);
    return user ? user.email : 'Email non disponible';
  }

  /**
   * Méthodes helper pour l'affichage des partenaires de commission
   */

  getOptionLabel(row: any): string {
    if (row.partner === 'AFIESCA') {
      return row.current ? row.current + '%' : 'Non configuré';
    }
    const option = row.options.find((o: any) => o.value === row.current);
    return option ? option.label : (row.current || 'Non configuré');
  }

  onAfiescaCommissionChange(row: any): void {
    const val = row.current;
    if (val !== null && val !== undefined && val !== '') {
      this.onChangeCommission(row.partner, String(val));
    }
  }

  onImageError(event: Event): void {
  const target = event.target as HTMLImageElement;
  if (target) {
    target.src = 'assets/images/logos/logo_assureurs.png';
  }
}

  getPartnerLogo(partner: string): string {
  return this.apiCredentialsService.getPartnerLogoPath(partner);
}

getPartnerLogoContainerClass(partner: string): string {
  const baseClass = 'partner-logo-container flex align-items-center justify-content-center border-round-md';
  const colorClasses: { [key: string]: string } = {
    'APRIL': 'bg-green-50',
    'CARDIF': 'bg-blue-50',
    'UTWIN': 'bg-orange-50',
    'NEOLIANE': 'bg-purple-50',
    'SWISSLIFE': 'bg-red-50',
    'AFIESCA': 'bg-indigo-50',
    'ZENIOO': 'bg-teal-50'
  };
  
  return `${baseClass} ${colorClasses[partner.toUpperCase()] || 'bg-gray-50'}`;
}


  getPartnerStatus(partner: string): string {
    // Basé sur la présence d'une configuration
    const commission = this.commissionListDisplay.find(c => c.partner === partner);
    if (commission?.current && commission.current !== '-') {
      return 'Configuré';
    }
    return 'En attente';
  }

  getPartnerSeverity(partner: string): 'success' | 'info' | 'warn' | 'danger' {
    const commission = this.commissionListDisplay.find(c => c.partner === partner);
    if (commission?.current && commission.current !== '-') {
      return 'success';
    }
    return 'warn';
  }

  getCurrentRateClass(current: string): string {
    if (!current || current === '-') {
      return 'text-orange-600';
    }
    return 'text-green-600';
  }

  getStatusIcon(current: string): string {
    if (!current || current === '-') {
      return 'pi pi-exclamation-triangle';
    }
    return 'pi pi-check-circle';
  }

  getStatusColor(current: string): string {
    if (!current || current === '-') {
      return 'text-orange-600';
    }
    return 'text-green-600';
  }

  getStatusText(current: string): string {
    if (!current || current === '-') {
      return 'Configuration requise';
    }
    return 'Taux configuré';
  }
}
